export const parseLinkContext = (
  arg: string
): { sku: string; lenderId?: string; additionalLinkContext?: string } => {
  const [sku, restParams] = arg.split('-linkParams-');

  const paramList = restParams ? restParams.split('&') : [];

  return paramList.reduce(
    (acc, curr) => {
      if (!curr) {
        return acc;
      }

      const [key, value] = curr.split('=');

      acc[key] = value ? decodeURIComponent(value) : '';
      return acc;
    },
    { sku } as {
      sku: string;
      lenderId?: string;
      additionalLinkContext?: string;
    }
  );
};
